export const SMALL_MOBILE_WIDTH = 360;
export const MOBILE_WIDTH = 576;
export const TAB_WIDTH = 768;
export const TAB_LANDSCAPE_WIDTH = 992;
export const DESKTOP_WIDTH = 1200;
export const DESKTOP_LARGE_WIDTH = 1440;
export const TAB_LARGE_WIDTH = 1024;
